module.exports = __webpack_public_path__ + "img/2.a2f1dd1a.jpg";